module.exports = __webpack_public_path__ + "static/media/logo.d38f2d89.png";